import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  const info = [
    { text: 'Years experience', count: '01' },
    { text: 'Completed Project', count: '25' },
    { text: 'Companies Work', count: '06' },
  ];

  return (
    <section className={` w-screen  `} id="about">
      <div className=" text-center w-[80%] mx-auto items-center justify-center ">
        <h3 className=" text-[20px] font-extrabold mt-10">
          About <span className="text-yellow-500">Me</span>
        </h3>
        <p className=" lg:text-slate-400 font-bold mt-2.5 mb-4 text-lg">
          My introduction
        </p>

        <div className=" flex md:flex-row flex-col-reverse items-center gap-6 lg:gap-6 px-10 max-w-6x1 mx-auto">
          <div className=" p-2 ">
            <motion.div
              className="  my-3 font-sans"
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{
                delay: 0.1,
                y: { type: 'spring', stiffness: 100 },
                opacity: { duration: 0.8 },
                ease: 'easeIn',
                duration: 1,
              }}
            >
              <p className=" text-justify lg:w-11/12 lg:mx-auto smooth bg-[#d7d7d7] text-black p-5 rounded-xl font-semibold ">
                Welcome! I'm James David, a full-stack developer dedicated to
                crafting exceptional digital experiences. I specialize in
                responsive, user-friendly websites and web applications,
                utilizing technologies like HTML, CSS, JavaScript, and React.js.
                With expertise in frontend and backend technologies, including
                Node.js, Express.js, MongoDB, and SQL Thank you for your
                interest—I look forward to creating something amazing together!
              </p>
              <div className=" flex mt-10 items-center gap-7 w-100% justify-center">
                {info.map((content) => (
                  <div key={content.text}>
                    <h3 className="lg:text-4x1  text-5x1 font-bold">
                      {' '}
                      {content.count} <span className=" text-cyan-600">+</span>{' '}
                    </h3>
                    <span>{content.text}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
          <div>
            <div className=" flex-1  lg:visible justify-center items-center">
              <motion.div
                className="lg:w-96 lg:h-full    lg:relative sm:w-10/12 lg:max-w-sm lg:aboutImg sm:mt-[60px] md:mt-[30px] lg:mt-9"
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{
                  delay: 0.1,
                  y: { type: 'spring', stiffness: 100 },
                  opacity: { duration: 0.8 },
                  ease: 'easeIn',
                  duration: 1,
                }}
              >
                <img
                  src={'/homeImage.png'}
                  alt=""
                  className=" w-full object-cover lg:rounded-[20px] rounded-full"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

//https://haniaimran.netlify.app/
